import { BaseGroupItem } from 'components/Builder/types';

const WINE_BUILDER_TOTAL = 6;

type ProductCountAndTotal = {
  productCount: number;
  totalCount: number;
};

type PromotionBuilders = Array<{
  completed: boolean;
  groups: Array<{ items: (BaseGroupItem | null)[]; groupId: string; threshold: number }>;
  promotionDescription: string;
}>;

export const makeWineProgressMsg = (
  productCountAndTotal: ProductCountAndTotal | null,
  promotionBuilders: PromotionBuilders,
  isWineBuilder: boolean,
): string | null => {
  if (!isWineBuilder || !promotionBuilders.length || !productCountAndTotal) {
    return null;
  }

  const secondGroupItemsCount = promotionBuilders[0]?.groups[1]?.items?.length;
  if (secondGroupItemsCount > 1) {
    return null;
  }

  if (productCountAndTotal.productCount < WINE_BUILDER_TOTAL) {
    return `${productCountAndTotal.productCount} added. Add ${
      WINE_BUILDER_TOTAL - productCountAndTotal.productCount
    } to qualify`;
  }

  return `${WINE_BUILDER_TOTAL} wines added. You've qualified for the offer`;
};
